import React, { useEffect, useState } from 'react'
import DocumentIcon from './icons/DocumentIcon'
import ChevronIcon from './icons/ChevronIcon'
import UploadRequestedDocument from './UploadRequestedDocument'
import ModalDialog from '../layouts/ModalDialog'
import { useDispatch, useSelector } from 'react-redux'
import { SET_SUCCESS } from '../../store/types'
import { clearUpdatedDocumentRequest } from '../../store/actions/documentRequestActions'
import PaymentStatus from './PaymentStatus'
import { slugify } from '../../utils'

const DocumentRequest = ({documentRequest, reload}) => {
    const [uploadingDocument, setUploadingDocument] = useState(false);
    const documentRequestsSelector = useSelector(state => state.documentRequests)
    const dispatch = useDispatch()


    useEffect(() => {
        if(documentRequestsSelector.updatedDocumentRequest){
            dispatch({
                type: SET_SUCCESS,
                payload: 'requested document uploaded successfully!'
            })
            dispatch(clearUpdatedDocumentRequest())
            reload()
            setTimeout(() => {
                setUploadingDocument(false)
            }, 50);
        }
        
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentRequestsSelector.updatedDocumentRequest, dispatch]);

    const handleDownload = async() => {
        // URL of the file to download
        const fileUrl = documentRequest.sampleDocumentUrl;
        const fileName = slugify(documentRequest.name); // Optional custom filename
    
        try {
            // Fetch the file as a blob
            const response = await fetch(fileUrl);
      
            if (!response.ok) {
              throw new Error('Failed to fetch file');
            }
      
            const blob = await response.blob();
      
            // Create a blob URL
            const blobUrl = URL.createObjectURL(blob);
      
            // Create an anchor element
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = fileName;
      
            // Append and trigger the download
            document.body.appendChild(anchor);
            anchor.click();
      
            // Cleanup
            anchor.remove();
            URL.revokeObjectURL(blobUrl);
          } catch (error) {
            console.error('Error downloading file:', error);
          }
      
    };

    return (
        <>
            <div className='w-full border border-dashed border-gray-300 rounded-[8px] p-3 flex items-start gap-x-2 transition duration-300 hover:shadow-lg'>
                <div className='relative'>
                    <DocumentIcon className={`w-7 h-7 text-gray-500`} />
                </div>
                <div className='w-full'>
                    <p className='text-sm mb-2'>{documentRequest.name}</p>
                    <PaymentStatus status={documentRequest.status} />
                    {documentRequest.sampleDocumentUrl && documentRequest.sampleDocumentUrl !== '' && 
                    <button onClick={()=>{handleDownload()}} className='text-gray-500 hover:text-gray-800 transition duration-200 text-xs text-left flex items-center gap-x-2 my-2' rel="noreferrer">
                        View/Download sample document 
                    </button>}

                    {documentRequest.status === 'PENDING' && <button onClick={()=>{setUploadingDocument(true)}} className='text-green-600 hover:text-vcm-purple my-2 transition duration-200 text-xs flex items-center gap-x-2'>See details and upload document <ChevronIcon className={`w-4 h-4 rotate-180`} /></button>}
                </div>
            </div>

            <ModalDialog
                shown={uploadingDocument} 
                closeFunction={()=>{setUploadingDocument(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Upload requested documentRequest: ${documentRequest?.name}`}
                maxWidthClass='max-w-3xl'
                hideActions={true}
            >
                <UploadRequestedDocument 
                    documentDetails={documentRequest}
                    reload={()=>reload()}
                    closeFunction={()=>{setUploadingDocument(false)}} 
                />

            </ModalDialog>
        </>
    )
}

export default DocumentRequest